export const TOGGLE_SIDE_MENU = 'TOGGLE_SIDE_MENU';
export const LOGIN            = 'LOGIN';
export const REGISTER         = 'REGISTER';
export const GET_PROFILE      = 'GET_PROFILE';
export const SEND_CONTACT     = 'SEND_CONTACT';
export const SEARCH_TAB       = 'SEARCH_TAB';
export const CLEAR_SEARCH       = 'CLEAR_SEARCH';

export const toggleSideMenu = () => {
  return {
    type: TOGGLE_SIDE_MENU
  }
};

export const login = (user, pass) => {
  return {
    type: LOGIN,
    url: window.__env.apiUrl + '/auth/login',
    user, 
    pass
  }
};

export const getProfile = (user, pass) => {
  return {
    type: GET_PROFILE,
    url: window.__env.apiUrl + '/user/profile',
    user, 
    pass
  }
};

export const register = (data) => {
  return {
    type: REGISTER,
    url: window.__env.apiUrl + '/auth/register',
    data
  }
};

export const sendContact = (data) => {
  return {
    type: SEND_CONTACT,
    url: window.__env.apiUrl + '/contact',
    data
  }
};

export const searchTab = (term) => {
  return {
    type: SEARCH_TAB,
    url: window.__env.apiUrl + '/tab/search',
    term
  }
};

export const clearSearch = () => {
  return {
    type: CLEAR_SEARCH,
  }
};



// WEBPACK FOOTER //
// ./src/actions/globalActions.js